import validateNumericInput from '../functions/validateNumericInput';
import isNumeric from '../functions/isNumeric';
import isAlphaNumeric from '../functions/isAlphaNumeric'; 
import _ from 'lodash';
import isAlphaNumericDash from './isAlphaNumericDash';
import isValidEmail from './isValidEmail'; 

// standard list validation 
const listValidation = (value, list) => {
    // validate rebate setup type 
    if(list.includes(value)) {
        return true; 
    }
    return false;
}

// list validation for object lists that do not share address
const listValidation2 = (value, list) => {
    // iterate over all elements of list 
    for (let i = 0; i < list.length; i++) {
        if (_.isEqual(value, list[i])) {
            return true; 
        }
    }
    return false; 
}

const dynamicValidation = (input, config, args, snackbarAlert) => { 
    // iterate over all values of config
    for (let i = 0; i < config.length; i++) {

        // if there is no input and column is not required then continue
        if (config[i]['ovrrequired'] === false && config[i]['required'] === false && (input[config[i]['columnid']] === null || input[config[i]['columnid']] === undefined || input[config[i]['columnid']] === '' || input[config[i]['columnid']] == {} )) {
            continue; 
        }   
        else if (config[i]['ovrrequired'] === false && config[i]['required'] === true && (input[config[i]['columnid']] === null || input[config[i]['columnid']] === undefined || input[config[i]['columnid']] === '' || input[config[i]['columnid']] == {} )) {
            snackbarAlert(true, config[i]['errormessage'], 'error'); 
            return config[i]['columnid']; 
        }

        // dynamic validation logic for validation type 
        if (config[i]['validation'] == 'alphanumeric') {
            if (!input[config[i]['columnid']] || !isAlphaNumeric(input[config[i]['columnid']]) || input[config[i]['columnid']] == '') {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'alphanumeric_space') {
            if (!input[config[i]['columnid']] || !isAlphaNumeric(input[config[i]['columnid']], true)) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] === 'alphanumeric_extended') { // add space and dash to check
            if (!input[config[i]['columnid']] || !isAlphaNumericDash(input[config[i]['columnid']], true)) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'id') {
            if (!input[config[i]['columnid']] || !listValidation(input[config[i]['columnid']], args[config[i]['columnid']])) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'id_v2') {
            if (!input[config[i]['columnid']] || !listValidation2(input[config[i]['columnid']], args[config[i]['columnid']])) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'select') {
            if (!input[config[i]['columnid']] || !listValidation(input[config[i]['columnid']], args[config[i]['columnid']])) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'money') {
            if (!input[config[i]['columnid']] || !validateNumericInput(input[config[i]['columnid']])) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            } 
        }
        else if (config[i]['validation'] == 'rate') {
            if (!input[config[i]['columnid']] || !isNumeric(input[config[i]['columnid']].replace('%', ''))) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'ach_numeric') {
            let configArgs = JSON.parse(config[i]['args']);
            // check that ACH info is required based on Payout Method choice
            let required = input[configArgs['arg1']]['requireachinfo']; 
            if ( // logic for required ach info 
                required && 
                (!input[config[i]['columnid']] || !isNumeric(input[config[i]['columnid']]) || input[config[i]['columnid']].length > parseInt(config[i]['inputlength']) || input[config[i]['columnid']] == '')
            ) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid'];  
            }
            else if ( // logic for optional ach info 
                !required && input[config[i]['columnid']] &&
                (!isNumeric(input[config[i]['columnid']], true) || ( input[config[i]['columnid']] && input[config[i]['columnid']].length > parseInt(config[i]['inputlength']) ))
            ) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'ach_id') {
            let configArgs = JSON.parse(config[i]['args']);
            // check that ACH info is required based on Payout Method choice
            let required = input[configArgs['arg1']]['requireachinfo']; 
            if ( // logic for required ach info 
                required && 
                (!input[config[i]['columnid']] || !listValidation(input[config[i]['columnid']], args[config[i]['columnid']]))
            ) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
            else if ( // logic for optional ach info 
                !required && input[config[i]['columnid']] &&
                (input[config[i]['columnid']] && !listValidation(input[config[i]['columnid']], args[config[i]['columnid']]))
            ) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'consortium_id') {
            let configArgs = JSON.parse(config[i]['args']);
            // check that portfolio is consortium type 
            let consortium = input[configArgs['arg1']]['consortium']; 
            // validation
            if (consortium && !listValidation(input[config[i]['columnid']], args[config[i]['columnid']])) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'select_with_override') {
            // get override boolean from args 
            let override = args[config[i]['columnid']]['override']; 
            // error logic with override
            if ( override ){ // if override flag do not run check 
                continue; 
            }
            else if (input[config[i]['columnid']] == null || !listValidation(input[config[i]['columnid']], args[config[i]['columnid']]['list'])) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        else if (config[i]['validation'] == 'rate_with_override') {
            let configArgs = JSON.parse(config[i]['args']);
            let override = input[configArgs['arg1']]; 
            // error logic with override
            if ( override ) { // if override flag do not run check 
                continue; 
            } 
            else if (!input[config[i]['columnid']] || !isNumeric(input[config[i]['columnid']].replace('%', ''))) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
        // email validation (uses regex)
        else if (config[i]['validation'] == 'email') {
            if (!isValidEmail(input[config[i]['columnid']])) {
                snackbarAlert(true, config[i]['errormessage'], 'error'); 
                return config[i]['columnid']; 
            }
        }
    }
    // return null on success
    return null; 
}

export default dynamicValidation; 